<template>
  <div class="public-content epay-trade">
    <div class="breadcrumb">交易明细</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="formInline.outOrderNo" placeholder="请输入订单号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select v-model="formInline.storeId" clearable :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select v-model="formInline.storeId" clearable :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select v-model="formInline.salesmanId" clearable :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="流水号:">
              <el-input v-model="formInline.tradeNo" placeholder="请输入流水号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易类型:">
              <el-select v-model="formInline.tradeType" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option v-for="(v, k) in $config.tradeType" :key="k" :label="v" :value="k" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易方式:">
              <el-select v-model="formInline.tradeMethod" placeholder="请选择" clearable>
                <el-option v-for="(v, k) in filterTradeMethod" :key="k" :label="v" :value="k" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付状态:">
              <el-select v-model="formInline.paymentStatus" placeholder="请选择" clearable>
                <el-option v-for="(v, k) in $config.paymentStatus" :key="k" :label="v" :value="k" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" round @click="onSubmit(1)">查询</el-button>
            <el-button class="search-ok" round @click="exportExcel"> 导出Excel </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%" fit>
          <el-table-column label="订单号" fixed="left" min-width="220px">
            <template v-slot="scope">
              <!-- <router-link :to="{path: './epayTradeDetail',query:{id: scope.row.id}}" class="color-blue"> {{ scope.row.outOrderNo }} </router-link> -->
              <span class="color-blue" @click="toPath(scope)">{{ scope.row.outOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="tradeNo" label="流水号" min-width="220px" />
          <el-table-column prop="store.salesman.userName" label="业务" min-width="120" />
          <el-table-column prop="store.code" label="平台号" min-width="100" />
          <el-table-column prop="store.name" label="平台名称" min-width="150" />
          <el-table-column prop="amount" label="金额" min-width="100px" />
          <el-table-column prop="tradeType" label="交易类型" min-width="100">
            <template v-slot="scope">
              <span>{{ $config.tradeType[scope.row.tradeType] || scope.row.tradeType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="tradeMethod" label="交易方式" min-width="110">
            <template v-slot="scope">
              <span>{{ $config.vpayTradeMethod[scope.row.tradeMethod] || scope.row.tradeMethod }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付状态" prop="paymentStatus" min-width="130">
            <template slot-scope="scope"> {{ $config.paymentStatus[scope.row.paymentStatus] || scope.row.paymentStatus }} </template>
          </el-table-column>
          <el-table-column prop="paymentDate" label="支付日期" min-width="200" />
          <el-table-column prop="dateCreated" label="创建日期" min-width="200" />
          <!-- <el-table-column prop="bonus" label="积分" min-width="100px" />
          <el-table-column prop="paymentType" label="支付类型" min-width="100">
            <template v-slot="scope">
              <span>{{ $config.paymentType[scope.row.paymentType]||scope.row.paymentType }}</span>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :query-info="queryInfo" @changePage="changePage" />
    </div>
    <CombinedDialog ref="dialogRef" />
  </div>
</template>
<script>
// "id", "tradeNo", "amount", "paymentType", "paymentStatus", "paymentDate", "outOrderNo", "tradeMethod", "tradeType", "payments"
import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName } from '@/api/crm'
import { tradePage, tradeExport } from '@/api/epay'
export default {
  name: 'EpayTrade',
  components: {
    VPagination, CombinedDialog
  },
  inject: ['reload'],
  data () {
    return {
      storeListByCode: [],
      storeListByName: [],
      salemanList: [],
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      value2: [
        this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      formInline: {
        dateEnd: '',
        dateStart: '',
        outOrderNo: '',
        salesmanId: '',
        storeId: '',
        tradeMethod: '',
        tradeNo: '',
        tradeType: ''
      },
      tableData: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      code: ''
    }
  },
  computed: {
    filterTradeMethod () { // ?
      let tradeType = this.formInline.tradeType

      let rawDict = this.$config.vpayTradeMethod
      // if (tradeType) {
      //   let destDict = {}
      //   if (tradeType === 'TRADE') {
      //     tradeType = 'CONSUME'
      //   }
      //   Object.keys(rawDict).filter(el => el.indexOf(tradeType) >= 0).forEach(k => {
      //     destDict[k] = rawDict[k]
      //   })
      //   return destDict
      // }
      return rawDict
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.dateStart = val[0]
          this.formInline.dateEnd = val[1]
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
      this.value2 = [this.formInline.dateStart, this.formInline.dateEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('salemanList')
    }
    this.onSubmit()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    // vpayChargeDetail?id=302&auditStatus=AUDITED
    toPath (scope) {
      if (scope.row.tradeType === 'CHARGE') {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
        this.$router.push({
          path: 'epayTradeDetail',
          query: {
            id: scope.row.id
          }
        })
      } else if (scope.row.tradeType === 'TRADE') {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
        this.$router.push({
          path: '/orderdetail',
          query: {
            orderNo: scope.row.outOrderNo,
            way: 1
          }
        })
      }
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    onSubmit (num) {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      this.queryInfo.pageNum = num || this.queryInfo.pageNum
      tradePage({ params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize }, data: this.formInline }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.content.map(a => {
            if (a.store?.salesman) {
              a.store.salesman.userName = this.$msg.filterBridal(a.store.salesman.userName)
            }
            return a
          })
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    getOrderStatus () {
      this.$refs.dialogRef.show('status', '订单状态', this.gridData)
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      // if (param.dateStart === '') {
      //   param.dateStart = this.$moment().subtract(1, 'months').format('YYYY-MM-DD')
      //   param.dateEnd = this.$moment().format('YYYY-MM-DD')
      // }
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      tradeExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '交易明细' + param.dateStart + '-' + param.dateEnd + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
@deep: ~">>>";
</style>
